import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star, Timer, Trophy, ChatsCircle } from "@phosphor-icons/react";

function formatRating(r) {
  if (r === null || r === undefined || r === 0) return "—";
  return `${r}/5`;
}

export function AdminMetrics() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/metrics");
        setData(data);
      } catch (_) {}
    })();
  }, []);

  const tiles = [
    {
      label: "Avg time to deliver",
      value: data ? (data.avg_hours_to_deliver ? `${data.avg_hours_to_deliver}h` : "—") : "—",
      icon: Timer,
      sub: data ? `${data.completed_projects} delivered` : "",
    },
    {
      label: "Avg satisfaction",
      value: data ? formatRating(data.avg_rating) : "—",
      icon: Star,
      sub: data ? `${data.survey_count} survey${data.survey_count === 1 ? "" : "s"}` : "",
    },
    {
      label: "Top performer",
      value: data?.designer_metrics?.length
        ? [...data.designer_metrics]
            .filter((d) => d.avg_rating != null && d.delivered_count > 0)
            .sort((a, b) => b.avg_rating - a.avg_rating)[0]?.name || "—"
        : "—",
      icon: Trophy,
      sub: "by rating",
    },
    {
      label: "Reviews captured",
      value: data ? data.survey_count : "—",
      icon: ChatsCircle,
      sub: "this period",
    },
  ];

  return (
    <div className="mb-10" data-testid="admin-metrics">
      <h2 className="font-display text-2xl mb-4 uppercase">Performance metrics</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#262626] border border-[#262626] mb-6">
        {tiles.map((t, i) => {
          const Icon = t.icon;
          return (
            <div key={i} className="bg-[#0a0a0a] p-5">
              <Icon size={20} className="text-[#FF2D2D]" />
              <div className="font-display text-2xl md:text-3xl mt-3 truncate" title={String(t.value)}>
                {t.value}
              </div>
              <div className="text-xs text-[#a3a3a3] uppercase tracking-wider">{t.label}</div>
              {t.sub && <div className="text-[10px] text-[#666] mt-1">{t.sub}</div>}
            </div>
          );
        })}
      </div>

      {/* Designer leaderboard */}
      {data?.designer_metrics?.length > 0 && (
        <div className="border border-[#262626]" data-testid="designer-leaderboard">
          <div className="grid grid-cols-12 gap-4 p-3 border-b border-[#262626] bg-[#0a0a0a] text-[10px] uppercase tracking-[0.3em] text-[#a3a3a3]">
            <div className="col-span-4">Designer</div>
            <div className="col-span-2 text-right">Delivered</div>
            <div className="col-span-3 text-right">Avg time</div>
            <div className="col-span-3 text-right">Rating</div>
          </div>
          {data.designer_metrics.map((d) => (
            <div
              key={d.designer_id}
              data-testid={`designer-row-${d.designer_id}`}
              className="grid grid-cols-12 gap-4 p-3 bg-[#0a0a0a] border-b border-[#1a1a1a] last:border-0 items-center"
            >
              <div className="col-span-4 font-semibold truncate">{d.name}</div>
              <div className="col-span-2 text-right tabular-nums">{d.delivered_count}</div>
              <div className="col-span-3 text-right tabular-nums text-[#a3a3a3]">
                {d.avg_hours_to_deliver != null ? `${d.avg_hours_to_deliver}h` : "—"}
              </div>
              <div className="col-span-3 text-right tabular-nums">
                {d.avg_rating != null ? (
                  <span className="text-[#FF2D2D] font-semibold">
                    {d.avg_rating} <span className="text-[#666] text-xs">({d.review_count})</span>
                  </span>
                ) : (
                  <span className="text-[#666]">—</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
